import Vue from 'vue'
import Vuex from 'vuex'
import { getUserRoutes } from '@/api'
import { constantRoutes } from '@/router'

Vue.use(Vuex)

// 递归转换组件
function filterAsyncRoutes(routes) {
    const res = []
    routes.forEach(route => {
        const tmp = { ...route }
        if (tmp.component) {
            if (tmp.component === 'Layout') {
                tmp.component = () => import('@/layout/index.vue')
            } else if (tmp.component === 'ParentView') {
                tmp.component = () => import('@/components/ParentView/index.vue')
            } else {
                // 清理路径，防止双斜杠
                const componentPath = tmp.component.replace(/^\/|\/$/g, '')
                tmp.component = () => import(`@/views/${componentPath}.vue`).catch(e => {
                    console.error(`组件加载失败: ${componentPath}`, e)
                    return { render: h => h('div', `❌ 找不到组件: ${componentPath}`) }
                })
            }
        }
        if (tmp.children && tmp.children.length) {
            tmp.children = filterAsyncRoutes(tmp.children)
        }
        res.push(tmp)
    })
    return res
}

// 标准化路由结构
function normalizeTopLevelPath(route) {
    const routePath = route.path || ''
    if (routePath.startsWith('/')) {
        return routePath
    }
    // 兼容旧数据库中顶级菜单仍保存 event、team 等相对路径的情况。
    if (route.component && route.component.endsWith('/index')) {
        return `/${route.component.replace(/\/index$/, '')}`
    }
    return `/${routePath}`
}

function normalizeBackendRoutes(routes) {
    return routes.filter(r => r.type !== 2).map(route => {
        const meta = { title: route.title, icon: route.icon, type: route.type }
        if (route.type === 1 && route.parentId === 0) {
            return {
                path: normalizeTopLevelPath(route),
                component: 'Layout',
                hidden: route.hidden === 1,
                meta: { ...meta, type: 0 },
                children: [
                    {
                        path: '',
                        component: route.component,
                        name: route.title,
                        meta: meta
                    }
                ]
            }
        }
        return {
            path: route.path,
            component: route.component,
            name: route.title,
            hidden: route.hidden === 1,
            meta: meta,
            children: route.children ? normalizeBackendRoutes(route.children) : []
        }
    })
}

export default new Vuex.Store({
    state: {
        token: localStorage.getItem('token') || '',
        routes: [],
        addRoutes: [],
        hasLoadedRoutes: false
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
            localStorage.setItem('token', token)
        },
        SET_ROUTES: (state, routes) => {
            state.addRoutes = routes
            state.routes = constantRoutes.concat(routes)
            state.hasLoadedRoutes = true
        },
        RESET_ROUTES: (state) => {
            state.hasLoadedRoutes = false
            state.routes = []
        }
    },
    actions: {
        GenerateRoutes({ commit }) {
            return new Promise(resolve => {
                getUserRoutes().then(res => {
                    // 即使 res.data 为空，流程也能走通
                    const normalizedData = normalizeBackendRoutes(res.data || [])
                    const accessedRoutes = filterAsyncRoutes(normalizedData)
                    accessedRoutes.push({ path: '*', redirect: '/404', hidden: true })
                    commit('SET_ROUTES', accessedRoutes)
                    resolve(accessedRoutes)
                }).catch(err => {
                    console.error("路由接口请求失败:", err)
                    // 即使失败，也要让流程走下去，避免死循环
                    commit('SET_ROUTES', [])
                    resolve([])
                })
            })
        },
        Logout({ commit }) {
            commit('SET_TOKEN', '')
            commit('RESET_ROUTES')
            localStorage.removeItem('token')
            location.reload()
        }
    }
})
